import { Icons } from '@commenda/kakashi';
import { getFileIcon } from '@commenda/utils';
import type { TChatDocumentKind } from './chat-document-mentions.types';

const WRAPPER_CLASS_NAME =
  'mr-xs inline-flex size-4 shrink-0 align-[-3px] text-fg-tertiary [&>svg]:size-full';

/** Leading glyph for a document or folder name: a folder, the file's type icon, or a plain document
 * when nothing is uploaded yet. Sized via the wrapper: some @commenda/icons glyphs don't forward
 * className. */
export function ChatDocumentIcon({
  kind,
  fileName,
}: {
  kind: TChatDocumentKind;
  fileName: string | null;
}) {
  const Glyph =
    kind === 'folder'
      ? Icons.Folder
      : fileName
        ? getFileIcon(fileName)
        : Icons.File02;

  return (
    <span aria-hidden="true" className={WRAPPER_CLASS_NAME}>
      <Glyph />
    </span>
  );
}
